import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment as env } from '../../environments/environment';
import { ApiAuthHttpClient } from '../http/ApiAuthHttpClient';
import { IAction, IActionFormData, IActionSubtype } from '../shared/model/action.model';

@Injectable({
    providedIn: 'root',
})
export class ActionService {
    public newActionCreated$: Subject<IAction> = new Subject<IAction>();

    constructor(private http: ApiAuthHttpClient) {}

    public createAction(action: IActionFormData): Observable<any> {
        return this.http
            .post(env.apiPath + `actions`, {
                ...action,
            })
            .pipe(
                tap((result: any) => this.newActionCreated$.next(result.data)),
                map((result: any) => result.data)
            );
    }

    public updateAction(action: IActionFormData): Observable<any> {
        return this.http
            .put(env.apiPath + `actions`, {
                ...action,
            })
            .pipe(map((result: any) => result.data));
    }

    public getActionTypes(): Observable<any> {
        return this.http.get(env.apiPath + `actions/types`).pipe(map((result: any) => result.data));
    }

    public getActionStatuses(): Observable<any> {
        return this.http.get(env.apiPath + `actions/statuses`).pipe(map((result: any) => result.data));
    }

    public assignAction(payload: any) {
        const { actionId, userId } = payload;
        return this.http
            .post(env.apiPath + `actions/assign-action`, {
                actionId,
                userId,
            })
            .pipe(map((result: any) => result.data));
    }

    public updateActionStatus(payload: any) {
        const { actionId, statusId } = payload;
        return this.http
            .put(env.apiPath + `actions/${actionId}/status`, {
                statusId,
            })
            .pipe(map((result: any) => result.data));
    }

    public getActionBoard(actionFilterParams: any = {}) {
        const httpParams = new HttpParams({ fromObject: actionFilterParams });
        return this.http.get(env.apiPath + `actions/board` + `?${httpParams}`).pipe(map((result: any) => result.data));
    }

    public getActionBoardSummary(actionFilterParams: any = {}) {
        const httpParams = new HttpParams({ fromObject: actionFilterParams });
        return this.http
            .get(env.apiPath + `actions/board-summary` + `?${httpParams}`)
            .pipe(map((result: any) => result.data));
    }

    public getAdminActionTypes() {
        return this.http.get(env.apiPath + `actions/admin-action-types`).pipe(map((result: any) => result.data));
    }

    getActions(params: any): Observable<any> {
        return this.http.post<{ data: any }>(env.apiPath + `actions/list`, params).pipe(map(({ data }) => data));
    }

    public getSubtypes(actionId: number): Observable<IActionSubtype[]> {
        return this.http
            .get<{ data: IActionSubtype[] }>(env.apiPath + `actions/subjects/${actionId}`)
            .pipe(map(({ data }) => data));
    }
}
